import { useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import plan1 from "../../assets/img/plan1.PNG";
import plan2 from "../../assets/img/plan2.PNG";
import plan3 from "../../assets/img/plan3.PNG";

const plans = [
  {
    title: "Plan de Lectura 1",
    image: plan1,
    file: "/pdfs/plan1.pdf",
  },
  {
    title: "Plan de Lectura 2",
    image: plan2,
    file: "/pdfs/plan2.pdf",
  },
  {
    title: "Plan de Lectura 3",
    image: plan3,
    file: "/pdfs/plan3.pdf",
  },
];

function Header() {
  const [done, setDone] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  return (
    <main className="flex flex-col items-center justify-center px-4 sm:mt-28 mt-20 font-bembo text-lg">
      <h1 className="mx-auto max-w-4xl font-display text-5xl font-bold tracking-normal text-slate-900 sm:text-7xl text-center mb-10">
        {done ? (
          "PLANES DE LECTURA"
        ) : (
          <Typewriter
            words={["PLANES DE LECTURA"]}
            loop={1}
            cursor
            cursorStyle="|"
            typeSpeed={80}
            deleteSpeed={40}
            delaySpeed={1000}
            onLoopDone={() => setDone(true)}
          />
        )}
      </h1>
      <h3 className="mx-auto max-w-1xl font-display text-2xl font-bold tracking-normal text-slate-900 sm:text-4xl">
        Planes de Lectura Anual
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl w-full">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-4 flex flex-col items-center"
          >
            <img
              src={plan.image}
              alt={`Imagen del plan de lectura: ${plan.title}`}
              className="w-full h-64 object-cover rounded-xl cursor-pointer"
              onClick={() => setActiveModal(index)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setActiveModal(index);
                }
              }}
            />
            <h2 className="text-center text-xl font-semibold text-slate-800 mt-4">
              {plan.title}
            </h2>

            {/* Modal */}
            {activeModal === index && (
              <div
                role="dialog"
                aria-modal="true"
                aria-labelledby={`modal-title-${index}`}
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
                onClick={() => setActiveModal(null)}
              >
                <div
                  tabIndex={-1}
                  className="bg-white rounded-xl p-6 w-80 shadow-lg text-center"
                  onClick={(e) => e.stopPropagation()}
                  // TODO: Add focus trap here for real modal accessibility
                >
                  <h3
                    id={`modal-title-${index}`}
                    className="text-xl font-bold mb-4"
                  >
                    {plan.title}
                  </h3>
                  <button
                    type="button"
                    onClick={() => {
                      window.open(plan.file, "_blank");
                      setActiveModal(null);
                    }}
                    className="block w-full mb-3 py-2 bg-white text-black rounded border border-black hover:bg-black hover:text-white transition-colors duration-200"
                  >
                    Abrir en nueva pestaña
                  </button>

                  <a
                    href={plan.file}
                    download
                    onClick={() => setActiveModal(null)}
                    className="block w-full py-2 bg-white text-black rounded border border-black hover:bg-black hover:text-white transition-colors duration-200"
                  >
                    Descargar en tu dispositivo
                  </a>

                  <button
                    type="button"
                    onClick={() => setActiveModal(null)}
                    className="mt-4 text-md text-gray-600 hover:underline"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <br />
      <br />
      <br />
    </main>
  );
}

export default Header;
